// extracted by mini-css-extract-plugin
export default {"uploadWrapper":"fileUpload_uploadWrapper__Aj0tY","xlWrapper":"fileUpload_xlWrapper__LvVCM","notificationPlacement":"fileUpload_notificationPlacement__luUWU"};